export default __webpack_public_path__ + "static/clubSwan-57a9c4caa1b18b6436fd98000b125cfd.png";